import { EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { distinctUntilChanged } from 'rxjs';
import { debounceTime, takeWhile, tap } from 'rxjs/operators';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { resetSelectedReport } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { incrementCurrentWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStepIndex, getPrimarySecurity, getSavedAnalysisPlanId, getSelectedReport, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { REPORT_TYPE_OPTIONS } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/constants';
import { LANGUAGE_OPTIONS, LEGACY_REPORT_TYPES } from 'CustomPDFReportsApp/ts/constants';
import { LEGACY_DATA_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { GenerateReportsModalSortColumn } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/enums/generate-reports-modal-sort-column.enum';
import { CustomPdfReportDataSourceEnum } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-data-source.enum';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { GenerateReportFolderableCollectionService } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/services/generate-report-folderable-collection-ajax.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { PreviewImageModalComponent } from 'NewAngular/features/components/modals/preview-image-modal/preview-image-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/services/generate-report-folderable-collection-ajax.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "FoldersApp/features/folders-shared/folderable-column-headers-component/folderable-column-headers.component";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i14 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/checkbox-group/checkbox-group.component";
import * as i15 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-modal-delete-modal/generate-modal-delete-modal.component";
import * as i16 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/generate-modal-folderable-list-item/generate-modal-folderable-list-item.component";
const _c0 = a0 => ({ "visibility": a0 });
const _c1 = () => ({});
const _c2 = () => ({ visibility: "hidden" });
const _c3 = a0 => ({ id: null, name: "Report Templates", permissions: a0 });
const _c4 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function CustomPdfReportFolderModalComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 6);
    i0.ɵɵtext(2, "Language:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-checkbox-group", 7);
    i0.ɵɵlistener("checkedHandler", function CustomPdfReportFolderModalComponent_Conditional_12_Template_ycn_checkbox_group_checkedHandler_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setLanguage($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("groupName", "languageCheckboxGroup")("displayVertical", false)("options", ctx_r1.languageOptions);
} }
function CustomPdfReportFolderModalComponent_Conditional_20_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function CustomPdfReportFolderModalComponent_Conditional_20_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.reportNameFilterInput.setValue("")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function CustomPdfReportFolderModalComponent_Conditional_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-search");
} }
function CustomPdfReportFolderModalComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("setSort", function CustomPdfReportFolderModalComponent_div_25_Template_div_setSort_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSort($event)); });
    i0.ɵɵelementStart(1, "div", 27)(2, "label", 28);
    i0.ɵɵelement(3, "input", 29)(4, "span", 30);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("columnConfig", ctx_r1.SAVED_ITEM_COLUMN_CONFIG)("sortableColumns", ctx_r1.GenerateReportsModalSortColumn)("sortColumn", ctx_r1.sortColumn)("sortDirection", ctx_r1.sortDirection);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(5, _c2));
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31)(1, "span");
    i0.ɵɵtext(2, "There are no items.");
    i0.ɵɵelementEnd()();
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_For_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-generate-modal-folderable-list-item", 34);
    i0.ɵɵlistener("errorHandler", function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_For_1_ng_template_1_Template_ycn_generate_modal_folderable_list_item_errorHandler_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.errorText = $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subItem_r6 = ctx.folderable;
    const ancestorInfo_r7 = ctx.ancestorInfo;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("folderable", subItem_r6)("ancestorInfo", ancestorInfo_r7)("baseResourceType", ctx_r1.baseResourceType);
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 33);
    i0.ɵɵtemplate(1, CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_For_1_ng_template_1_Template, 1, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderable_r8 = ctx.$implicit;
    const listItemFragment_r9 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", listItemFragment_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c4, folderable_r8, i0.ɵɵpureFunction1(3, _c3, i0.ɵɵpureFunction0(2, _c1))));
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 35);
    i0.ɵɵtext(1, " To change the timeframe and to hide or display the benchmark in the Level Chart, update selections on the security's Quote tab before generating your Tearsheet. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_For_1_Template, 3, 8, null, null, _forTrack0, true);
    i0.ɵɵtemplate(2, CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_p_2_Template, 2, 0, "p", 32);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.filteredReports);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.currentReportTypeInternalName === ctx_r1.tearsheetsInternalName);
} }
function CustomPdfReportFolderModalComponent_Conditional_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CustomPdfReportFolderModalComponent_Conditional_27_Conditional_0_Template, 3, 0, "div", 31)(1, CustomPdfReportFolderModalComponent_Conditional_27_Conditional_1_Template, 3, 1);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.folderableCollectionService.loading && ctx_r1.folderableCollectionService.items.length === 0 ? 0 : 1);
} }
function CustomPdfReportFolderModalComponent_Conditional_28_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1, " No Reports. ");
    i0.ɵɵelementEnd();
} }
function CustomPdfReportFolderModalComponent_Conditional_28_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1, " No Reports.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span")(4, "a", 37);
    i0.ɵɵlistener("click", function CustomPdfReportFolderModalComponent_Conditional_28_Conditional_1_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.clearReportFilters()); });
    i0.ɵɵtext(5, "Clear Filters");
    i0.ɵɵelementEnd()()();
} }
function CustomPdfReportFolderModalComponent_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CustomPdfReportFolderModalComponent_Conditional_28_Conditional_0_Template, 2, 0, "div", 36)(1, CustomPdfReportFolderModalComponent_Conditional_28_Conditional_1_Template, 6, 0, "div", 36);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.folderableCollectionService.userHasNoData ? 0 : 1);
} }
function CustomPdfReportFolderModalComponent_Conditional_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 22);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
const OWNER_OPTIONS = [
    {
        label: 'Me',
        value: 'me',
        checked: true,
    },
    {
        label: 'Shared with me',
        value: 'shared_with_me',
        checked: true,
    },
    {
        label: 'Public',
        value: 'public',
        checked: true,
    },
];
/**
 * Custom PDF Report Modal Component
 *
 * This component displays the menu of Custom PDF Reports organized by report type.
 * It is typically the first modal displayed in the Custom PDF Report generation process.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class CustomPdfReportFolderModalComponent {
    constructor(customPDFReportService, accountsService, featureService, folderableCollectionService, store) {
        this.customPDFReportService = customPDFReportService;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.folderableCollectionService = folderableCollectionService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.reportNameFilterInput = new FormControl('', { nonNullable: true });
        this.securityId = '';
        this.baseResourceType = null;
        this.modalOpen = false;
        this.currentReportTypeInternalName = '';
        this.tearsheetsInternalName = LEGACY_REPORT_TYPES.TEARSHEET;
        this.ownerOptions = OWNER_OPTIONS;
        this.reportTypeOptions = [];
        this.languageOptions = [];
        this.showLanguageSetting = false;
        this.sortColumn = GenerateReportsModalSortColumn.USER_MODIFY_DATE;
        this.sortDirection = DESC;
        this.selectedReport = null;
        this.submitButtonText = 'Start';
        this.onePageReportTypes = new Set(Object.values(LEGACY_REPORT_TYPES));
        this.isAlive = true;
        this.isReportRegeneration = false;
        this.isReportValidatingOrInvalid = false;
        this.SAVED_ITEM_COLUMN_CONFIG = {
            [GenerateReportsModalSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [GenerateReportsModalSortColumn.USER_MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [GenerateReportsModalSortColumn.OWNER]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.processViewResponse = (response) => {
            this.errorText = undefined;
            this.filteredReports = response.data.items;
            if (!this.filteredReports.length) {
                if (this.baseResourceType === FolderableType.WATCHLIST) {
                    this.errorText =
                        'The files could not be generated because the security list ' +
                            'does not contain at least one supported security type.';
                }
                else if (this.baseResourceType === FolderableType.ANALYSIS_PLAN) {
                    this.errorText =
                        'No interactive analysis reports have been found; ' +
                            'please create a report with interactive analysis modules ' +
                            'or contact support.';
                }
            }
        };
        this.mapStateToComponent = (state) => {
            const { securityId, securityListGroup } = getPrimarySecurity(state);
            this.isReportRegeneration = state.reportRegeneration;
            this.securityId = securityId ?? '';
            this.securityListGroup = securityListGroup;
            const selectedReport = getSelectedReport(state);
            this.currentReportTypeInternalName = selectedReport?.report_type;
            if (this.securityId?.startsWith('watchlist-')) {
                this.baseResourceType = FolderableType.WATCHLIST;
            }
            else if (getSavedAnalysisPlanId(state) !== null) {
                this.baseResourceType = FolderableType.ANALYSIS_PLAN;
            }
            else {
                this.baseResourceType = null;
            }
            const isRegeneration = this.isReportRegeneration && this.folderableCollectionService.items?.length === 0;
            const reportSelected = Object.keys(selectedReport).length;
            if (state.primarySecurity.securityId &&
                (!reportSelected ||
                    (isRegeneration &&
                        selectedReport.wizard_steps[0].eventName ===
                            CustomPDFReportModalEventName.SHOW_REPORT_MENU_MODAL)) &&
                !this.modalOpen &&
                getCurrentWizardStepIndex(state) === 0) {
                this.errorText = undefined;
                this.fetchReports();
                this.openModal();
            }
            if (Object.keys(selectedReport).length) {
                this.selectedReport = selectedReport;
            }
            else {
                this.selectedReport = null;
            }
            this.submitButtonText = this.currentReportTypeInternalName in this.onePageReportTypes ? 'Generate' : 'Start';
        };
        this.GenerateReportsModalSortColumn = GenerateReportsModalSortColumn;
        this.accountsService.getUserPreferences().subscribe({
            next: ({ use_generic_data_display, custom_pdf_reports_generate_report_modal_filters }) => {
                this.dataSource =
                    !this.featureService.userHasFeatures([LEGACY_DATA_FEATURE]) || use_generic_data_display
                        ? CustomPdfReportDataSourceEnum.DEFAULT
                        : CustomPdfReportDataSourceEnum.LEGACY;
                if (custom_pdf_reports_generate_report_modal_filters) {
                    const filterPrefs = custom_pdf_reports_generate_report_modal_filters;
                    this.reportNameFilterInput.setValue(filterPrefs.name);
                    this.mapStateToOwnerOptions(filterPrefs.owner);
                    this.mapStateToReportTypeOptions(filterPrefs.reportType);
                    this.mapStateToLanguageOptions(filterPrefs.language);
                    this.sortColumn = filterPrefs.sortColumn;
                    this.sortDirection = filterPrefs.sortDirection;
                }
            },
            error: () => {
                this.dataSource = CustomPdfReportDataSourceEnum.LEGACY; // TODO: change this to DEFAULT when data switch happens
                // https://app.asana.com/0/1207424818771538/1207992229300869/f
            },
        });
        this.accountsService.getClientGroupPreferences().subscribe((preferences) => {
            this.showLanguageSetting = preferences.show_pdf_language_setting;
        });
        this.reportCollectionSubscription = this.folderableCollectionService.viewResponse$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe({
            next: (response) => {
                if (response !== null) {
                    this.processViewResponse(response);
                }
            },
            error: (err) => {
                this.errorText =
                    err.error.error_message ||
                        'Unable to fetch reports. Please refresh the page or contact support.';
                this.filteredReports = [];
                this.folderableCollectionService.loading = false;
            },
        });
    }
    ngOnInit() {
        this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
        this.reportNameFilterInput.valueChanges
            .pipe(
        // Clear the selected report to prevent race conditions where reports clear after starting generation
        tap(() => this.clearSelectedReport()), debounceTime(300), distinctUntilChanged())
            .subscribe(() => this.refreshReportCollection());
        this.reportTypeOptions = REPORT_TYPE_OPTIONS;
        this.languageOptions = LANGUAGE_OPTIONS;
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    mapStateToOwnerOptions(filter) {
        this.ownerOptions = this.ownerOptions.map((option) => {
            return {
                ...option,
                checked: filter[option.value],
            };
        });
    }
    mapStateToReportTypeOptions(filter) {
        if (!filter) {
            return;
        }
        this.reportTypeOptions = this.reportTypeOptions.map((option) => {
            return {
                ...option,
                checked: option.value in filter ? filter[option.value] : true,
            };
        });
    }
    mapStateToLanguageOptions(filter) {
        if (!filter) {
            return;
        }
        this.languageOptions = this.languageOptions.map((option) => {
            return {
                ...option,
                checked: option.value in filter ? filter[option.value] : true,
            };
        });
    }
    fetchReports(force = false) {
        this.clearSelectedReport();
        this.refreshReportCollection(force);
    }
    refreshReportCollection(force = false) {
        if (!this.securityId)
            return;
        const ownerFilter = this.ownerOptions.reduce((acc, curr) => {
            acc[curr.value] = curr.checked;
            return acc;
        }, {});
        const reportTypeFilter = this.reportTypeOptions.reduce((acc, curr) => {
            acc[curr.value] = curr.checked;
            return acc;
        }, {});
        const languageFilter = this.languageOptions.reduce((acc, curr) => {
            acc[curr.value] = curr.checked;
            return acc;
        }, {});
        const fetchParams = {
            dataSource: this.dataSource,
            name: this.reportNameFilterInput.value,
            baseResourceType: this.baseResourceType,
            owner: ownerFilter,
            reportType: reportTypeFilter,
            language: languageFilter,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection,
        };
        if (this.baseResourceType === FolderableType.WATCHLIST) {
            fetchParams.securitylistName = this.securityId;
        }
        else {
            fetchParams.securityId = this.securityId;
        }
        this.folderableCollectionService.refreshData(fetchParams, force);
    }
    setOwner(checkboxResults) {
        if (this.ownerOptions.every((option) => option.checked === checkboxResults[option.value]))
            return;
        this.ownerOptions = this.ownerOptions.map((option) => ({
            ...option,
            checked: checkboxResults[option.value],
        }));
        this.fetchReports();
    }
    setReportType(checkboxResults) {
        if (this.reportTypeOptions.every((option) => option.checked === checkboxResults[option.value]))
            return;
        this.reportTypeOptions = this.reportTypeOptions.map((option) => ({
            ...option,
            checked: checkboxResults[option.value],
        }));
        this.fetchReports();
    }
    setLanguage(checkboxResults) {
        if (this.languageOptions.every((option) => option.checked === checkboxResults[option.value]))
            return;
        this.languageOptions = this.languageOptions.map((option) => ({
            ...option,
            checked: checkboxResults[option.value],
        }));
        this.fetchReports();
    }
    clearSelectedReport() {
        if (!this.isReportRegeneration) {
            this.store.dispatch(resetSelectedReport());
        }
    }
    clearReportFilters() {
        this.ownerOptions = OWNER_OPTIONS;
        this.reportTypeOptions = REPORT_TYPE_OPTIONS;
        this.languageOptions = LANGUAGE_OPTIONS;
        this.reportNameFilterInput.setValue('');
        this.fetchReports();
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorText = undefined;
        this.isReportValidatingOrInvalid = false;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
        this.clearSelectedReport();
    }
    isGenerateableReport(report) {
        return report !== null && report !== undefined && Object.keys(report).length > 0 && 'report_type' in report;
    }
    isReportSelected() {
        return this.isGenerateableReport(this.selectedReport);
    }
    forward() {
        if (this.isReportSelected() && this.isGenerateableReport(this.selectedReport)) {
            if (this.baseResourceType === FolderableType.WATCHLIST) {
                this.isReportValidatingOrInvalid = true;
                this.customPDFReportService
                    .validateReportSecurityList('report_id' in this.selectedReport ? this.selectedReport.report_id : 0, this.securityId, this.securityListGroup, this.selectedReport.report_type in this.onePageReportTypes)
                    .subscribe({
                    next: (response) => {
                        this.errorText = response.message_text;
                        this.isReportValidatingOrInvalid =
                            this.errorText.includes('Security list is too large') ||
                                this.errorText.includes('Selected list has no securities');
                        if (!this.isReportValidatingOrInvalid) {
                            this.closeModal();
                            this.store.dispatch(incrementCurrentWizardStep());
                            this.broadcastWizardStepEvent.emit();
                        }
                    },
                    error: () => {
                        this.errorText = 'Error validating report';
                    },
                });
            }
            else {
                this.closeModal();
                this.store.dispatch(incrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
    trackFolderable(folderable) {
        switch (folderable.resourceType) {
            case 'folder': {
                const folder = folderable.item;
                return `folder-${folder.id}`;
            }
            case 'custom_pdf_report': {
                const report = folderable.item;
                return `custompdfreport-${report.id}`;
            }
            default: {
                const report = folderable.item;
                return `legacyreport-${report.report_name}`;
            }
        }
    }
    setSort(sort) {
        this.sortColumn = sort.sortColumn;
        this.sortDirection = sort.sortDirection;
        this.fetchReports();
    }
}
CustomPdfReportFolderModalComponent.ɵfac = function CustomPdfReportFolderModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPdfReportFolderModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i4.GenerateReportFolderableCollectionService), i0.ɵɵdirectiveInject(i5.Store)); };
CustomPdfReportFolderModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomPdfReportFolderModalComponent, selectors: [["ycn-custom-pdf-report-folder-modal"]], viewQuery: function CustomPdfReportFolderModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PreviewImageModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewImageModalComponent = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            BulkActionSelectionService,
            GenerateReportFolderableCollectionService,
            FolderExpansionService,
            { provide: FolderableCollectionServiceBase, useExisting: GenerateReportFolderableCollectionService },
        ])], decls: 32, vars: 25, consts: [["listItemFragment", ""], [3, "closeModalHandler", "modalBaseClass", "open", "extraModalClasses"], [3, "closeModalHandler", "header"], [1, "modal-body", 2, "padding", "0"], [1, "modal-section", "bg-panel", "pt-12", "pb-12"], [1, "form-inline", "mb-1"], [1, "form-label", "form-label-thin", "mr-2"], [3, "checkedHandler", "groupName", "displayVertical", "options"], [1, "form-inline"], [1, "modal-section"], [1, "mt-2", "mb-12", "d-flex", "align-items-center"], [1, "text-bold", 3, "textContent"], [1, "width-180", "ml-auto"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Folder or File", "data-test-id", "name_filter_input", 1, "form-control", "field-input", 3, "formControl"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent"], [1, "bg-yc-blue-75", 3, "ngStyle"], [1, "page-progress-bar"], [1, "table", "table-airy", "table-hover", "file-table", "overflow-auto"], ["class", "thead", "ycn-folderable-column-headers", "", 3, "columnConfig", "sortableColumns", "sortColumn", "sortDirection", "setSort", 4, "ngIf"], [1, "tbody"], [3, "loaderMessage"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "errorText", "submitButtonText", "disableSubmission"], [1, "btn", "btn-transparent", 3, "click"], ["ycnIcon", "", 3, "name"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "setSort", "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [1, "file-td-control", "td"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "custom-control-indicator"], [1, "get-started-small", "flex-auto"], ["class", "footnote", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "errorHandler", "folderable", "ancestorInfo", "baseResourceType"], [1, "footnote"], [1, "get-started", "flex-auto"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"]], template: function CustomPdfReportFolderModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportFolderModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "div", 6);
        i0.ɵɵtext(6, "Owner:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "ycn-checkbox-group", 7);
        i0.ɵɵlistener("checkedHandler", function CustomPdfReportFolderModalComponent_Template_ycn_checkbox_group_checkedHandler_7_listener($event) { return ctx.setOwner($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 5)(9, "div", 6);
        i0.ɵɵtext(10, "Report Type:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ycn-checkbox-group", 7);
        i0.ɵɵlistener("checkedHandler", function CustomPdfReportFolderModalComponent_Template_ycn_checkbox_group_checkedHandler_11_listener($event) { return ctx.setReportType($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(12, CustomPdfReportFolderModalComponent_Conditional_12_Template, 4, 3, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9)(14, "div", 10);
        i0.ɵɵelement(15, "div", 11);
        i0.ɵɵelementStart(16, "div", 12)(17, "div", 13);
        i0.ɵɵelement(18, "input", 14);
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵconditionalCreate(20, CustomPdfReportFolderModalComponent_Conditional_20_Template, 2, 1, "button", 16)(21, CustomPdfReportFolderModalComponent_Conditional_21_Template, 2, 1, "button", 16);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(22, "div", 17);
        i0.ɵɵelement(23, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 19);
        i0.ɵɵtemplate(25, CustomPdfReportFolderModalComponent_div_25_Template, 5, 6, "div", 20);
        i0.ɵɵelementStart(26, "div", 21);
        i0.ɵɵconditionalCreate(27, CustomPdfReportFolderModalComponent_Conditional_27_Template, 2, 1)(28, CustomPdfReportFolderModalComponent_Conditional_28_Template, 2, 1);
        i0.ɵɵconditionalCreate(29, CustomPdfReportFolderModalComponent_Conditional_29_Template, 1, 1, "ycn-loading-symbol", 22);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(30, "ycn-simple-modal-footer", 23);
        i0.ɵɵlistener("cancelHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_footer_cancelHandler_30_listener() { return ctx.exitModalHandler(); })("submitHandler", function CustomPdfReportFolderModalComponent_Template_ycn_simple_modal_footer_submitHandler_30_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(31, "ycn-generate-modal-folderable-delete-modal");
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen)("extraModalClasses", "modal-dialog");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("groupName", "ownerCheckboxGroup")("displayVertical", false)("options", ctx.ownerOptions);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("groupName", "reportTypeCheckboxGroup")("displayVertical", false)("options", ctx.reportTypeOptions);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showLanguageSetting ? 12 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.reportNameFilterInput.value ? "Search Results" : "Report Templates");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formControl", ctx.reportNameFilterInput);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.reportNameFilterInput.value ? 20 : 21);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(22, _c0, ctx.folderableCollectionService.loading ? "visible" : "hidden"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.folderableCollectionService.dataParams);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.items ? 27 : !ctx.folderableCollectionService.loading ? 28 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.showLoading && ctx.folderableCollectionService.loading ? 29 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("cancelButtonText", "Reset")("errorText", ctx.errorText)("submitButtonText", ctx.submitButtonText)("disableSubmission", ctx.selectedReport === null && ctx.selectedReport !== i0.ɵɵpureFunction0(24, _c1) || ctx.isReportValidatingOrInvalid || !(ctx.selectedReport == null ? null : ctx.selectedReport.wizard_steps));
    } }, dependencies: [i6.NgIf, i6.NgTemplateOutlet, i6.NgStyle, i7.FolderableColumnHeadersComponent, i8.DefaultValueAccessor, i8.NgControlStatus, i9.IconDirective, i10.LoadingSymbolComponent, i11.ModalBaseComponent, i12.SimpleModalFooterComponent, i13.SimpleModalHeaderComponent, i8.FormControlDirective, i14.CheckboxGroupComponent, i15.GenerateModalDeleteModalComponent, i16.GenerateModalFolderableListItemComponent], encapsulation: 2 });
